import { TooltipHost, DirectionalHint } from 'office-ui-fabric-react/lib/Tooltip';
import InboxPlusPivotViewState from 'owa-mail-inbox-plus-store/lib/store/schema/InboxPlusPivotViewState';
import * as React from 'react';
import getInboxPlusPivotDisplayProperties from 'owa-mail-inbox-plus-store/lib/selectors/getInboxPlusPivotDisplayProperties';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { pivotToggled } from '../actions/internalActions';
import getPivotToggleTooltipText from '../selectors/getPivotToggleTooltipText';
import { observer } from 'mobx-react-lite';
import InboxClassificationFilter from 'owa-mail-inbox-plus-store/lib/store/schema/InboxClassificationFilter';
import { focusedOtherPivotsToggled } from '../actions/internalActions';
import { inboxPlusFocusedOtherToggle } from './PivotEnableDisableDialog.locstring.json';
import loc from 'owa-localize';
import { Label } from 'office-ui-fabric-react/lib/Label';

const styles = require('./PivotEnableDisableDialog.scss');

export interface PivotToggleProps {
    pivot: InboxPlusPivotViewState;
}

export default observer(function PivotToggle(props: PivotToggleProps) {
    const pivotDisplayProperties = getInboxPlusPivotDisplayProperties(
        props.pivot.InboxClassificationFilter
    );
    const toggleFunction = React.useCallback(
        (evt, checked) => {
            props.pivot.InboxClassificationFilter === InboxClassificationFilter.Focused
                ? focusedOtherPivotsToggled(checked)
                : pivotToggled(props.pivot, checked);
        },
        [props.pivot]
    );
    const onRenderTooltipContent = React.useCallback(() => getTooltipContent(props.pivot), [
        props.pivot.recentSenders,
    ]);

    const toggleId = `toggle-${props.pivot.InboxClassificationFilter}`;
    const labelId = `label-${props.pivot.InboxClassificationFilter}`;

    return (
        <TooltipHost
            tooltipProps={{
                onRenderContent: onRenderTooltipContent,
                calloutProps: {
                    target: `#${labelId}`,
                },
            }}
            id={`${props.pivot.InboxClassificationFilter}`}
            directionalHint={DirectionalHint.bottomCenter}>
            <div className={styles.toggleContainer}>
                <Label id={labelId} className={styles.toggleLabel} htmlFor={toggleId}>
                    {props.pivot.InboxClassificationFilter === InboxClassificationFilter.Focused
                        ? loc(inboxPlusFocusedOtherToggle)
                        : pivotDisplayProperties.displayText}
                </Label>
                <Toggle
                    checked={props.pivot.isEnabled}
                    onChange={toggleFunction}
                    id={toggleId}
                    styles={{ root: { marginBottom: 0 } }}
                />
            </div>
        </TooltipHost>
    );
});

const getTooltipContent = (pivot: InboxPlusPivotViewState): JSX.Element => {
    const tooltipText = getPivotToggleTooltipText(pivot.InboxClassificationFilter);
    return (
        <div className={styles.toggleTooltipContainer}>
            <span className={styles.pivotDescription}>{tooltipText}</span>
            {pivot.InboxClassificationFilter !== InboxClassificationFilter.Focused && (
                <span>{pivot.recentSenders.join(', ')}</span>
            )}
        </div>
    );
};
